import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * PublicRoute
 * Componente para rutas que solo deben ser accesibles si el usuario NO está autenticado.
 * Si el usuario ya tiene sesión, lo redirige al Dashboard (root).
 */
const PublicRoute = ({ children }) => {
    const { isAuthenticated, checkingAuth } = useAuth();

    if (checkingAuth) {
        // Opcional: Mostrar loading spinner mientras se verifica auth
        return <div>Cargando...</div>;
    }

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PublicRoute;
